export default __webpack_public_path__ + "static/media/image1.178d03ca.png";